import { render, staticRenderFns } from "./RouteEditForm.vue?vue&type=template&id=963bc4e4&scoped=true&"
import script from "./RouteEditForm.vue?vue&type=script&lang=js&"
export * from "./RouteEditForm.vue?vue&type=script&lang=js&"
import style0 from "./RouteEditForm.vue?vue&type=style&index=0&id=963bc4e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963bc4e4",
  null
  
)

export default component.exports